import { useQuery } from '@tanstack/react-query';
// eslint-disable-next-line no-restricted-imports
import { useStore } from 'membership-management-portal/src/store';

import { getAccount } from '../graphql/getAccount';
import { Flags, useFlag } from '../utils/featureFlags';

export const useGetAccount = (enabled = true) => {
  const userAccessProfileFlag = useFlag(Flags.USER_ACCESS_PROFILE);
  const accountId = useStore((state) => state.accountId);
  return useQuery({
    queryKey: ['getAccount', accountId, userAccessProfileFlag],
    queryFn: () => getAccount({ userAccessProfileFlag }),
    retry: false,
    staleTime: Infinity,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    enabled: enabled,
  });
};
